export const flexMapperWithIndex: any = {
  0: 1,
  1: 1,
  2: 0.5,
  3: 1,
}

export const headerData = [
  {
    title: 'File Name',
  },
  {
    title: 'Processed Date/Time',
  },
  {
    title: 'Status',
  },
  {
    title: 'Actions',
  },
]

export const headerDataFileContent = [
  {
    title: 'Request ID',
  },
  {
    title: 'MID',
  },
  {
    title: 'Key',
  },
  {
    title: 'Key',
  },
  {
    title: 'Key',
  },
  {
    title: 'Key',
  },
  {
    title: 'Upload Status',
  },
  {
    title: 'Failure Reason',
  },
  {
    title: 'Action',
  },
]

export const flexMapperWithIndexFileContent: any = {
  0: 1,
  1: 1,
  2: 1,
  3: 1,
  4: 1,
  5: 1,
  6: 1,
  7: 1,
  8: 1,
}

export const syncBulkFileContent = [
  {
    title: 'Sr. No.',
  },
  {
    title: 'Parent Type',
  },
  {
    title: 'Parent ID',
  },
  {
    title: 'MID',
  },
  {
    title: 'Upload Status',
  },
  {
    title: 'Failure Reason',
  },
  {
    title: 'Action',
  },
]

export const flexMapperSyncBulkFileContent: any = {
  0: 1,
  1: 1,
  2: 1,
  3: 1,
  4: 1,
  5: 1,
  6: 1,
}
